/**
 * @param {object} params
 * @param {number} params.orderTotalUsd
 * @param {number} params.thresholdUsd
 * @returns {{ irsReportingRequired: boolean, requiresSsnUi: boolean }}
 */
export function resolveSfhSellTaxComplianceGate({
  orderTotalUsd,
  thresholdUsd,
}) {
  const threshold = thresholdUsd ?? 0;
  const hit = orderTotalUsd >= threshold;
  return { irsReportingRequired: hit, requiresSsnUi: hit };
}
